<div class="loading-container" [class.loading-container--compact]="compact">
    <svg
        class="loading-spinner"
        xmlns="http://www.w3.org/2000/svg"
        [attr.width]="compact ? 28 : 50"
        [attr.height]="compact ? 28 : 50"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#000000"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" />
        <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" />
    </svg>
    <p class="loading-message">{{ message }}</p>
</div>
